import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import styled from "styled-components";
// import NewCustomerAddressModal from "common/components/Modals/NewCustomerAddressModal";

const BroadbandFacts = ({ planId, flow, isfromAuth, ...props }) => {
	// const mobilityPageData = useSelector(
	// 	(state) => state.ProspectWidgets_MobilityData
	// );
	const factsData = useSelector(
		(state) => state.ProspectWidgets_WirelessPlansData.broadbandFacts
	);
	const htmlText = factsData?.[planId];
	// const [openModal, setOpenModal] = useState(false);

	if (htmlText) {
		return (
			<>
				<FactsWrapper>
					<div
						dangerouslySetInnerHTML={{
							__html: htmlText,
						}}
						className={isfromAuth ? "from-auth" : ""}
					/>
				</FactsWrapper>
				{/* {!!openModal && (
					<NewCustomerAddressModal
						pageData={mobilityPageData}
						hideZipCode={openModal}
						closeNCModal={setOpenModal}
					/>
				)} */}
			</>
		);
	} else return <></>;
};

const FactsWrapper = styled.div``;

export default BroadbandFacts;
